import React, { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import { LazyLoader } from "Layout/lazy-loader";
import AppRouter from "./router/index";
import { useDispatch, useSelector } from "react-redux";
import { getUserRequest } from "./redux/reducers/AuthReducer";
import { getItem } from './services/storage-service';
import APP_CONSTANTS from "./constants/app-constants";
import { GoogleOAuthProvider } from '@react-oauth/google';
import appConstants from "./constants/app-constants";
import 'antd/dist/antd.css';

function App() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.AuthReducer.user)

  useEffect(() => {
    const token = getItem(APP_CONSTANTS.ACCESS_TOKEN);

    if (token) {
      dispatch(getUserRequest());
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <React.Suspense fallback={<LazyLoader />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <HashRouter>
          {
            localStorage.getItem(appConstants.ACCESS_TOKEN) && !userDetails ?
              <LazyLoader />
              :
              <AppRouter />
          }
        </HashRouter>
      </React.Suspense>
    </GoogleOAuthProvider>
  );
}

export default App;
